import { z } from 'zod';

const zUserSettings = z.object({
    user: z.object({}).default({}),
    agency: z.object({
        defaultPropertyManagerId: z.number().nullable().optional(),
        showPortfolioMirroring: z.boolean().optional(),
    }),
});

type UpdateSettingsFormValues = z.infer<
    typeof zUserSettings
>;

export { zUserSettings, UpdateSettingsFormValues };
